import { render } from "./VinIMMO.vue?vue&type=template&id=89f98398&scoped=true"
import script from "./VinIMMO.vue?vue&type=script&lang=js"
export * from "./VinIMMO.vue?vue&type=script&lang=js"

import "./VinIMMO.vue?vue&type=style&index=0&id=89f98398&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f98398"]])

export default __exports__